import { useTranslation } from 'next-i18next'
import React from 'react'

import type { useCoupon } from '@/hooks/useCoupon'
import { OrderSummaryContent } from '@/shared/components/flows/OrderSummary'
import type { QuoteDataContextValue } from '@flows-ui/stepRenderer'

import type { useFlowSummary } from './useFlowSummary'

export interface FlowOrderSummaryProps {
  coupon: ReturnType<typeof useCoupon>
  formatCurrency: (amount: number) => string
  i18nNamespace: string
  isCouponPending: boolean
  isQuoteStep: boolean
  onApplyCoupon: () => void
  placement: 'inline' | 'sidebar'
  quoteDataValue: QuoteDataContextValue
  summary: ReturnType<typeof useFlowSummary>
}

export const FlowOrderSummary = ({
  coupon,
  formatCurrency,
  i18nNamespace,
  isCouponPending,
  isQuoteStep,
  onApplyCoupon,
  summary,
}: FlowOrderSummaryProps) => {
  const { t } = useTranslation()
  const productName = t(`${i18nNamespace}:headerLabel`)

  return (
    <OrderSummaryContent
      title={
        isQuoteStep
          ? productName
          : t('sharedFlows_common:orderSummary.checkout.title', { productName })
      }
      planTitle={summary.selectedPlanTitle}
      activeExtensions={summary.activeExtensions}
      startDate={!isQuoteStep ? summary.formattedStartDate : undefined}
      renewalDate={!isQuoteStep ? summary.renewalDate : undefined}
      priceLabel={summary.priceLabel}
      formattedPremium={summary.formattedPremium}
      priceInterval={summary.priceInterval}
      appliedDiscount={summary.appliedDiscount}
      formatCurrency={formatCurrency}
      appliedCoupon={coupon.appliedCoupon}
      couponCode={coupon.code}
      onCouponCodeChange={coupon.setCode}
      onApplyCoupon={onApplyCoupon}
      isCouponPending={isCouponPending}
      couponError={coupon.error}
    />
  )
}
